
import { NgModule } from '@angular/core';
import { LoadingSpinnerComponent } from './loading-spinner.component';


@NgModule({
    imports: [
    ],
    exports: [LoadingSpinnerComponent],
    declarations: [LoadingSpinnerComponent],
    providers: [],
})
export class LoadingSpinnerModule { }
